const sanitizeError = (error = "") => {
	const response = error?.response?.data;
	if (response?.errors?.[0]?.message) {
		return response.errors[0].message;
	} else if (response?.exceptionMessage) {
		return response.exceptionMessage;
	} else if (error?.message) {
		const isCancelled = error.message === "canceled";

		if (isCancelled) return "";

		return error.message;
	} else {
		return error;
	}
};

export default sanitizeError;
